import { useSearchParams } from "react-router-dom";
import { StoreTab } from "../components/admin/StoreTab";
import { PortalShell } from "../components/ProtectedRoute";
import { OverviewTab, SuppliersTab, PackagesTab, CountriesTab, OrdersTab, CustomersTab, TicketsTab, SettingsTab, ConnectorsTab } from "../components/admin/AdminTabs";

const TABS = [["overview", "Overview"], ["store", "Afrinet store"], ["suppliers", "Suppliers"], ["packages", "Packages & pricing"], ["countries", "Countries"],
  ["orders", "Orders"], ["customers", "Customers"], ["tickets", "Support"], ["settings", "Free domains & markup"], ["connectors", "Connectors"]];
const VIEWS = { store: StoreTab, overview: OverviewTab, suppliers: SuppliersTab, packages: PackagesTab, countries: CountriesTab, orders: OrdersTab,
  customers: CustomersTab, tickets: TicketsTab, settings: SettingsTab, connectors: ConnectorsTab };

export default function AdminPortal() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "overview";
  const View = VIEWS[tab] || OverviewTab;
  return (
    <PortalShell testid="admin-backoffice-dashboard" title="HostAfricair Backoffice" subtitle="Suppliers, pricing, countries and orders across Africa."
      tabs={TABS} active={tab} onTab={(t) => setSp({ tab: t })}>
      <View />
    </PortalShell>
  );
}
